import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopOrderVehicleInput,
    PopOrderVehicle,
    UpdatePopOrderVehicleInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopOrderVehicleService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPopOrderVehicles(): Promise<PopOrderVehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopOrderVehicles
                })
            ).data.listPopOrderVehicles.items;
            if (data) return data as PopOrderVehicle[];
        } catch (error) {
            console.error('Error finding PopOrderVehicle:', error);
            return null;
        }
    }

    async PopOrderVehiclesByPopOrder(
        orderId: string
    ): Promise<PopOrderVehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PopOrderVehiclesByPopOrder,
                    variables: {
                        orderId
                    }
                })
            ).data.PopOrderVehiclesByPopOrder.items;
            if (data) return data as PopOrderVehicle[];
        } catch (error) {
            console.error('Error finding PopOrderVehicle:', error);
            return null;
        }
    }

    async createPopOrderVehicle(
        input: CreatePopOrderVehicleInput
    ): Promise<PopOrderVehicle> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopOrderVehicle,
                    variables: {
                        input
                    }
                })
            ).data.createPopOrderVehicle;
            if (date) return date as PopOrderVehicle;
        } catch (error) {
            console.error('Error creating PopOrderVehicle:', error);
            return null;
        }
    }

    async updatePopOrderVehicle(
        input: UpdatePopOrderVehicleInput
    ): Promise<PopOrderVehicle> {
        return this.c(input);
    }

    async c(input: UpdatePopOrderVehicleInput): Promise<PopOrderVehicle> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopOrderVehicle,
                    variables: {
                        input
                    }
                })
            ).data.updatePopOrderVehicle;
            if (date) return date as PopOrderVehicle;
        } catch (error) {
            console.error('Error updated PopOrderVehicle:', error);
            return null;
        }
    }
}
